import React, { useState, useEffect, useRef } from "react";
import DefaultLayout from "../components/DefaultLayout";
import axios from "axios";
import { message, Input, Modal, Select, TimePicker, Row, Col, Table, Button, DatePicker, Empty } from "antd";
import config from "../config";
import { getCurrencySymbol } from "../utils/currencyHelper";
import { useCurrency } from "../contexts/ValidationContext";
import Invoice from "../components/Invoice.js";
import CloseButton from "../components/CloseButton";
import moment from "moment";
import * as XLSX from "xlsx";
import { jwtDecode } from "jwt-decode";
import { PrinterOutlined, UserOutlined, TableOutlined, CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import paymentMethodMap from "../utils/paymentMethodMap"; // Import the payment method mapping
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;
const { RangePicker: TimeRangePicker } = TimePicker;

const TransactionRecord = () => {
  const apiBaseUrl = config.REACT_APP_API_BASE_URL;
  const [transactionData, setTransactionData] = useState([]);
  const [tempTransactionData, setTempTransactionData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [cashierName, setCashierName] = useState([]);
  const [tableNumber, setTableNumber] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedCashier, setSelectedCashier] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [timeRange, setTimeRange] = useState([null, null]);
  const [dateRange, setDateRange] = useState([moment().startOf('day'), moment().endOf('day')]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const invoiceRef = useRef();
  const { currency } = useCurrency();
  const symbol = getCurrencySymbol(currency);
  const [currentUser, setCurrentUser] = useState(null);

  // Filter states
  const [methodOpen, setMethodOpen] = useState(false);
  const [cashierOpen, setCashierOpen] = useState(false);
  const [tableOpen, setTableOpen] = useState(false);

  const handleMethodDropdownVisibleChange = (open) => {
    setMethodOpen(open);
  };

  const handleCashierDropdownVisibleChange = (open) => {
    setCashierOpen(open);
  };

  const handleTableDropdownVisibleChange = (open) => {
    setTableOpen(open);
  };

  const closeInvoiceModal = () => {
    setSelectedInvoice(null);
    setShowInvoiceModal(false);
  };

  const calculateSelectedInvoiceData = (record) => {
    console.log("line 224: ", record);
    setSelectedInvoice(record);
    setShowInvoiceModal(true);
  };

   const handleDisabledDate = (current) => {
      // `current` is the date being rendered in the calendar
      if (!current) {
        return false;
      }
  
     // Return true if the date is in the future
     return current && current > dayjs().endOf('day');

      return false;
    };

  const getAllTransactions = async () => {
    try {
      const [startDate, endDate] = dateRange || [];

      if (!startDate || !endDate) {
        return;
      }

      // Construct UTC start and end of the selected days
      const filterObject = {
        startDate: startDate.clone().startOf("day").utc().toISOString(),
        endDate: endDate.clone().endOf("day").utc().toISOString(),
      };

      const { data } = await axios.post(
        `${apiBaseUrl}/api/payments/dateBetween`,
        filterObject
      );

      const sortedData = data.sort((a, b) =>
        moment(b.date).isAfter(moment(a.date)) ? 1 : -1
      );

      setTransactionData(sortedData);
      setTempTransactionData(sortedData);

      // Extract unique payment methods from all transactions
      const methods = [...new Set(data.map((item) => item.method))];
      setPaymentMethods(methods);

      // Extract unique cashierName, tableNo from transaction data (like StaffTransactionRecordPage)
      const uniqueUserIds = Array.from(
        new Set(sortedData.map((record) => record.cashierName))
      ).filter(Boolean);
      setCashierName(uniqueUserIds);

      const uniqueTableNumbers = Array.from(
        new Set(sortedData.map((record) => record.tableNo))
      ).filter(Boolean);
      setTableNumber(uniqueTableNumbers);
    } catch (error) {
      console.log(error);
    }
  };

  //new addded
  const [voidedItemsData, setVoidedItemsData] = useState([]);
  const [voidedItemsFilters, setVoidedItemsFilters] = useState({
    dateRange: dateRange,
    timeRange: null,
    cashier: null,
    table: null,
  });

  const applyVoidedItemsFilters = (filters) => {
    const { dateRange, timeRange, cashier, table } = filters;
    const [startDate, endDate] = dateRange || [];
    const endOfDay = endDate ? endDate.clone().endOf("day") : null;
    const [startTime, endTime] = timeRange || [null, null];

    const filtered = voidedItemsData.filter((item) => {
      const itemDate = moment(item.date);
      const itemTime = moment(item.time).format("HH:mm");

      const isWithinDateRange =
        startDate && endOfDay
          ? itemDate.isSameOrAfter(startDate, "day") &&
          itemDate.isSameOrBefore(endOfDay, "day")
          : true;

      const isWithinTimeRange =
        startTime && endTime
          ? moment(itemTime, "HH:mm").isBetween(
            moment(startTime, "HH:mm"),
            moment(endTime, "HH:mm"),
            "minute",
            "[]"
          )
          : true;

      const isCashierMatch = cashier ? item.userId === cashier : true;
      const isTableMatch = table
        ? String(item.tableNumber) === String(table)
        : true;

      return (
        isWithinDateRange && isWithinTimeRange && isCashierMatch && isTableMatch
      );
    });
    console.log('filters: ', filters);
    console.log('filtered: ', filtered);
    console.log('voidedItemsData: ', voidedItemsData);

    setFilteredVoidedItems(filtered);
  };

  const [filteredVoidedItems, setFilteredVoidedItems] = useState([]);

  const fetchVoidedItems = async () => {
    try {
      const { data } = await axios.get(`${apiBaseUrl}/api/orders/voided-items`);
      setVoidedItemsData(data);
    } catch (error) {
      console.error("Error fetching voided items:", error);
      message.error("Failed to fetch voided items.");
    }
  };

  // This effect will run whenever voidedItemsData or voidedItemsFilters changes
  useEffect(() => {
    // Only run if there's actually data to filter
    if (voidedItemsData.length > 0) {
      applyVoidedItemsFilters(voidedItemsFilters);
    }
  }, [voidedItemsData, voidedItemsFilters]); // Dependency array

  const getVoidedItemsDataByDateRange = (startDate, endDate) => {
    console.log("startDate:", startDate, " endDate: ", endDate);
    console.log("voidedItemsData; ", voidedItemsData);
    console.log("filteredVoidedItems; ", filteredVoidedItems);

    const filteredVoidedData = filteredVoidedItems.reduce(
      (acc, item) => {
          acc.totalQuantity += 1;
          acc.totalQuantityOfItems += item.quantity;
          acc.totalAmount += item.amount;
        return acc;
      },
      {
        totalQuantity: 0,
        totalQuantityOfItems: 0,
        totalAmount: 0,
      }
    );
    console.log("filteredVoidedData: ", filteredVoidedData);

    return filteredVoidedData;
  };

  const getAllTransactionsWithDates = async (startDate, endDate) => {
    try {
      if (!startDate || !endDate) {
        return;
      }

      const filterObject = {
        startDate: startDate,
        endDate: endDate,
      };

      const { data } = await axios.post(
        `${apiBaseUrl}/api/payments/dateBetween`,
        filterObject
      );

      const sortedData = data.sort((a, b) =>
        moment(b.date).isAfter(moment(a.date)) ? 1 : -1
      );
      setTransactionData(sortedData);
      setTempTransactionData(sortedData);

      // Extract unique payment methods from all transactions
      const methods = [...new Set(data.map((item) => item.method))];
      setPaymentMethods(methods);

      // Extract unique cashierName, tableNo from transaction data (like StaffTransactionRecordPage)
      const uniqueUserIds = Array.from(
        new Set(sortedData.map((record) => record.cashierName))
      ).filter(Boolean);
      setCashierName(uniqueUserIds);

      const uniqueTableNumbers = Array.from(
        new Set(sortedData.map((record) => record.tableNo))
      ).filter(Boolean);
      setTableNumber(uniqueTableNumbers);
    } catch (error) {
      console.log(error);
      if (error.response?.status === 404) {
        setTransactionData([]);
        setTempTransactionData([]);
        setPaymentMethods([]);
        setTableNumber([]);
        setCashierName([]);
      }
    }
  };

  const formatDateTime = (isoString) => {
    const dateObj = new Date(isoString);
    const date = dateObj.toLocaleDateString().split("T")[0];
    const time = dateObj.toTimeString().split(" ")[0];
    return { date, time };
  };

  const applyFilters = () => {
    const filtered = tempTransactionData.filter((transaction) => {
      const transactionTime = moment(transaction.date).format("HH:mm");

      const isWithinTimeRange =
        timeRange && timeRange[0] && timeRange[1]
          ? moment(transactionTime, "HH:mm").isBetween(
            moment(timeRange[0], "HH:mm"),
            moment(timeRange[1], "HH:mm"),
            "minute",
            "[]"
          )
          : true;

      const isMethodMatch = selectedMethod ? transaction.method === selectedMethod : true;
      const isCashierMatch = selectedCashier ? transaction.cashierName === selectedCashier : true;
      const isTableMatch = selectedTable ? transaction.tableNo === selectedTable : true;

      return isWithinTimeRange && isMethodMatch && isCashierMatch && isTableMatch;
    });

    setTransactionData(filtered);
  };

  useEffect(() => {
    applyFilters();
  }, [selectedMethod, selectedCashier, selectedTable, timeRange, tempTransactionData]);

  // Get current user
  useEffect(() => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    if (auth) {
      const { token } = auth;
      try {
        const decoded = jwtDecode(token);
        setCurrentUser(decoded.userId);
      } catch (err) {
        console.error("Invalid token", err);
      }
    }
  }, []);

  // Load today's transactions on component mount
  useEffect(() => {
    if (dateRange[0] && dateRange[1]) {
      getAllTransactionsWithDates(
        dateRange[0].clone().startOf("day").utc().toISOString(),
        dateRange[1].clone().endOf("day").utc().toISOString()
      );
      //new addded
      fetchVoidedItems();
    }
  }, []);

  const handleDateRangeChange = (dates) => {
    if (!dates || dates.length !== 2 || !dates[0] || !dates[1]) return;

    const [startDate, endDate] = dates;
    setDateRange(dates);

    const filterObject = {
      startDate: startDate.clone().startOf("day").utc().toISOString(),
      endDate: endDate.clone().endOf("day").utc().toISOString(),
    };

    getAllTransactionsWithDates(filterObject.startDate, filterObject.endDate);

    //new addded
    const newFilters = { ...voidedItemsFilters, dateRange: dates };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);

  };

  const handleTimeRangeChange = (times) => {
    setTimeRange(times);

    //new addded
    const newFilters = { ...voidedItemsFilters, timeRange: times };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const handlePaymentMethodChange = (value) => {
    setSelectedMethod(value);
  };

  const handleCashierNameChange = (value) => {
    setSelectedCashier(value);

    //new addded
    const newFilters = { ...voidedItemsFilters, cashier: value };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const handleTableNumberChange = (value) => {
    setSelectedTable(value);

    //new addded
    const newFilters = { ...voidedItemsFilters, table: value };
    setVoidedItemsFilters(newFilters);
    applyVoidedItemsFilters(newFilters);
  };

  const handleTransactionDataPrint = () => {
    const ws = XLSX.utils.json_to_sheet(
      transactionData.map((item, index) => ({
        No: index + 1,
        "User ID": item.cashierName,
        Date: formatDateTime(item.date).date,
        Time: formatDateTime(item.date).time,
        "Invoice No.": item.invoiceId,
        "Table No.": item.tableNo,
        "Payment Method": item.method,
        "Gross Amount": item.billAmount.total,
        "Discount": item.billAmount.discount,
        "Net Amount": item.billAmount.subTotal,
        "Services": (item.billAmount.services || []).reduce((acc, service) => acc + parseFloat(service.totalPrice || 0), 0).toFixed(2),
        "Deposit": item.billAmount.deposit.amount,
        "Payable Amount": item.billAmount.payableAmount,
        "Revenue": item.billAmount.grandTotal,
      }))
    );

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Transaction Data");

    const filename = `transaction_data_${moment().format("YYYY-MM-DD")}.xlsx`;
    XLSX.writeFile(wb, filename);
  };

  const calculateTotals = () => {
    const totalGrossAmount = transactionData.reduce((sum, record) => {
      const total = parseFloat(record.billAmount.total || 0);
      const serviceSum = (record.billAmount.services || []).reduce(
        (acc, service) => acc + parseFloat(service.totalPrice || 0),
        0
      );
      return sum + total + serviceSum;
    }, 0);

    const totalDiscount = transactionData.reduce((sum, record) => {
      const discount = record.billAmount.discount;
      return sum + (discount !== undefined && discount !== null ? parseFloat(discount) : 0);
    }, 0);

    const totalNetAmount = transactionData.reduce((sum, record) => {
      const subTotal = parseFloat(record.billAmount.subTotal || 0);
      const serviceSum = (record.billAmount.services || []).reduce(
        (acc, service) => acc + parseFloat(service.totalPrice || 0),
        0
      );
      return sum + subTotal + serviceSum;
    }, 0);

    const totalService = transactionData.reduce((sum, record) => {
      const serviceSum = (record.billAmount.services || []).reduce(
        (acc, service) => acc + parseFloat(service.totalPrice || 0),
        0
      );
      return sum + serviceSum;
    }, 0);

    const totalDeposit = transactionData.reduce((sum, record) => {
      const depositAmount = record.billAmount.deposit.amount;
      return sum + (depositAmount !== undefined && depositAmount !== null ? parseFloat(depositAmount) : 0);
    }, 0);

    const totalPayable = transactionData.reduce((sum, record) => {
      const payableAmount = record.billAmount.payableAmount;
      return sum + (payableAmount !== undefined && payableAmount !== null ? parseFloat(payableAmount) : 0);
    }, 0);

    const totalRevenue = transactionData.reduce((sum, record) => {
      const depositAmount = record.billAmount.deposit.amount;
      const payableAmount = record.billAmount.payableAmount;
      if (
        depositAmount !== undefined &&
        depositAmount !== null &&
        payableAmount !== undefined &&
        payableAmount !== null
      ) {
        return sum + parseFloat(payableAmount) + parseFloat(depositAmount);
      }
      return sum;
    }, 0);

    //new addded
    const cashiersAggregation = transactionData.reduce(
      (acc, transaction) => {
        const cashierName = transaction.cashierName;
        if (!acc[cashierName]) {
          acc[cashierName] = {
            cashierAmount: 0,
            cashierName: cashierName,
          };
        }

        const depositAmount = parseFloat(
          transaction.billAmount?.deposit?.amount || 0
        );

        const payableAmount = parseFloat(
          transaction.billAmount?.payableAmount || 0
        );

        acc[cashierName].cashierAmount += payableAmount + depositAmount;

        return acc;
      },
      {}
    );
    let totalPax = 0;
    let totalTax = 0;
    const allUsersAggregation = transactionData.reduce(
      (acc, transaction) => {
        console.log("voided: ", transaction);
        const method = transaction.method || "Unknown";
        const serviceAmount = (transaction.billAmount?.services || []).reduce(
          (sum, service) => sum + parseFloat(service.totalPrice || 0),
          0
        );
        const grossAmounts =
          parseFloat(transaction.billAmount?.total || 0) + serviceAmount;
        const discount = parseFloat(transaction.billAmount?.discount || 0);
        const netAmount =
          parseFloat(transaction.billAmount?.subTotal || 0) + serviceAmount;
        // const revenue = parseFloat(transaction.billAmount.grandTotal || 0);
        const payable = parseFloat(transaction.billAmount?.payableAmount || 0);

        totalPax += transaction.pax;

        totalTax += (transaction.billAmount?.taxes || []).reduce(
          (sum, tax) => sum + parseFloat(tax.taxAmount || 0),
          0
        );

        if (!acc[method]) {
          acc[method] = {
            count: 0,
            depositCount: 0,
            totalGrossAmountsForEachMethod: 0,
            totalDiscountForEachMethod: 0,
            totalNetSalesForEachMethod: 0,
            totalServiceForEachMethod: 0,
            totalRevenueForEachMethod: 0,
            totalPayableForEachMethod: 0,
            totalDepositForEachMethod: 0,
            items: [],
          };
        }

        acc[method].count += 1;
        acc[method].totalGrossAmountsForEachMethod += grossAmounts;
        acc[method].totalDiscountForEachMethod += discount;
        acc[method].totalNetSalesForEachMethod += netAmount;
        acc[method].totalServiceForEachMethod += serviceAmount;
        acc[method].totalRevenueForEachMethod += payable;
        acc[method].totalPayableForEachMethod += payable;
        acc[method].items.push(transaction);

        if (
          transaction.billAmount?.deposit &&
          transaction.billAmount?.deposit?.haveDeposit
        ) {
          const depositMethod =
            transaction.billAmount.deposit.method || "Unknown";
          const depositAmount = parseFloat(
            transaction.billAmount.deposit.amount || 0
          );

          if (!acc[depositMethod]) {
            acc[depositMethod] = {
              count: 0,
              depositCount: 0,
              totalGrossAmountsForEachMethod: 0,
              totalDiscountForEachMethod: 0,
              totalNetSalesForEachMethod: 0,
              totalServiceForEachMethod: 0,
              totalRevenueForEachMethod: 0,
              totalPayableForEachMethod: 0,
              totalDepositForEachMethod: 0,
              items: [],
            };
          }
          acc[depositMethod].depositCount += 1;
          acc[depositMethod].totalDepositForEachMethod += depositAmount;
          acc[depositMethod].totalRevenueForEachMethod += depositAmount;
          if (depositMethod !== method) {
            acc[depositMethod].items.push(transaction);
          }
        }

        return acc;
      },
      {}
    );

    //cashiers
    const cashiers = Object.values(cashiersAggregation);

    return {
      allData: Object.entries(allUsersAggregation).map(
        ([
          method,
          {
            count,
            depositCount,
            totalGrossAmountsForEachMethod,
            totalDiscountForEachMethod,
            totalNetSalesForEachMethod,
            totalServiceForEachMethod,
            totalRevenueForEachMethod,
            totalPayableForEachMethod,
            totalDepositForEachMethod,
            items,
          },
        ]) => ({
          method: paymentMethodMap[method] || method,
          count,
          depositCount,
          totalGrossAmountsForEachMethod:
            totalGrossAmountsForEachMethod.toFixed(2),
          totalDiscountForEachMethod: totalDiscountForEachMethod.toFixed(2),
          totalNetSalesForEachMethod: totalNetSalesForEachMethod.toFixed(2),
          totalServiceForEachMethod: parseFloat(
            totalServiceForEachMethod
          ).toFixed(2),
          totalRevenueForEachMethod: totalRevenueForEachMethod.toFixed(2),
          totalPayableForEachMethod: totalPayableForEachMethod.toFixed(2),
          totalDepositForEachMethod: totalDepositForEachMethod.toFixed(2),
          items,
        })
      ),
      totalGrossAmount,
      totalDiscount,
      totalNetAmount,
      totalService,
      totalRevenue,
      totalPayable,
      totalDeposit,
      totalTransactions: transactionData.length,
      //new addded
      cashiers,
      totalPax,
      totalTax,
    };
  };

  const sendTransactionDataToPrinter = async (payload) => {
    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/printreportselected`,
        payload
      );

      if (response.data.success) {
        message.success("Transaction receipt sent to printer successfully!");
      } else {
        throw new Error(
          response.data.message || "Failed to print transaction receipt."
        );
      }
    } catch (error) {
      console.error("Error sending transaction data to printer:", error);
      message.error("Failed to print transaction receipt.");
    }
  };

  const handleTransactionDataPrintSelected = () => {
    const {
      allData,
      totalGrossAmount,
      totalDiscount,
      totalNetAmount,
      totalService,
      totalRevenue,
      totalPayable,
      totalDeposit,
      totalTransactions,
      //new addded
      cashiers,
      totalPax,
      totalTax,
    } = calculateTotals();

    // Calculate fromReceiptNo and toReceiptNo
    const sortedTransactions = transactionData
      .filter((transaction) => transaction.invoiceId)
      .sort((a, b) => a.invoiceId.localeCompare(b.invoiceId));

    const fromReceiptNo =
      sortedTransactions.length > 0 ? sortedTransactions[0].invoiceId : null;
    const toReceiptNo =
      sortedTransactions.length > 0
        ? sortedTransactions[sortedTransactions.length - 1].invoiceId
        : null;

    // Extract fromSelectedDate and toSelectedDate from dateRange
    const [fromSelectedDate, toSelectedDate] = dateRange || [null, null];

    const selectedPrinterId = localStorage.getItem("selectedPrinterId");

    const payload = {
      title: "Settlement of the Selected Period",
      preparedBy: currentUser,
      date: new Date().toLocaleDateString(),
      time: new Date().toLocaleTimeString(),
      summary: {
        totalTransactions,
        totalGrossAmount,
        totalDiscount,
        totalNetAmount,
        totalService,
        totalRevenue,
        totalPayable,
        totalDeposit,
        fromReceiptNo,
        toReceiptNo,
        fromSelectedDate: fromSelectedDate
          ? fromSelectedDate.format("YYYY-MM-DD")
          : null,
        toSelectedDate: toSelectedDate
          ? toSelectedDate.format("YYYY-MM-DD")
          : null,
        totalPax,
        totalTax: totalTax.toFixed(2),
      },
      paymentBreakdown: allData,
      selectedPrinterId: selectedPrinterId,
      //new addded
      cashiers: cashiers,
      voidedItemsData: getVoidedItemsDataByDateRange(voidedItemsFilters.dateRange[0], voidedItemsFilters.dateRange[1]),
    };

    sendTransactionDataToPrinter(payload);
  };

  const columns = [
    {
      title: "No",
      key: "index",
      render: (text, record, recordIndex) => (
        <span>{(pagination.current - 1) * pagination.pageSize + recordIndex + 1}</span>
      ),
    },
    { title: "User ID", dataIndex: "cashierName" },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => {
        const formattedDate = formatDateTime(date).date;
        return <span>{formattedDate}</span>;
      },
    },
    {
      title: "Time",
      dataIndex: "date",
      render: (date) => {
        const formattedTime = formatDateTime(date).time;
        return <span>{formattedTime}</span>;
      },
    },
    {
      title: "Invoice No.",
      dataIndex: "invoiceId",
      render: (invoiceId, record) => (
        <a
          onClick={() => {
            calculateSelectedInvoiceData(record);
            setShowInvoiceModal(true);
          }}
          style={{
            cursor: "pointer",
            color: "#1890ff",
            textDecoration: "underline",
          }}
        >
          {invoiceId}
        </a>
      ),
    },
    { title: "Table No.", dataIndex: "tableNo" },
    { title: "Payment Method", dataIndex: "method" },
    {
      title: "Gross Amount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const total = parseFloat(record.billAmount?.total || 0);
        const serviceSum = (record.billAmount?.services || []).reduce(
          (acc, service) => acc + parseFloat(service.totalPrice || 0),
          0
        );
        const grossAmount = total + serviceSum;
        return <span>{parseFloat(grossAmount).toFixed(2)}</span>;
      },
    },
    {
      title: "Discount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const discount = record.billAmount?.discount;
        if (discount !== undefined && discount !== null) {
          return <span>{parseFloat(discount).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
    {
      title: "Net Amount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const subTotal = parseFloat(record.billAmount?.subTotal || 0);
        const serviceSum = (record.billAmount?.services || []).reduce(
          (acc, service) => acc + parseFloat(service.totalPrice || 0),
          0
        );
        const netAmount = subTotal + serviceSum;
        return <span>{parseFloat(netAmount).toFixed(2)}</span>;
      },
    },
    {
      title: "Services (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const serviceSum = (record.billAmount?.services || []).reduce(
          (acc, service) => acc + parseFloat(service.totalPrice || 0),
          0
        );
        return <span>{parseFloat(serviceSum).toFixed(2)}</span>;
      },
    },
    {
      title: "Deposit (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const depositAmount = record.billAmount?.deposit.amount;
        if (depositAmount !== undefined && depositAmount !== null) {
          return <span>{parseFloat(depositAmount).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
    {
      title: "Payable Amount (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const payableAmount = record.billAmount?.payableAmount;
        if (payableAmount !== undefined && payableAmount !== null) {
          return <span>{parseFloat(payableAmount).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
    {
      title: "Revenue (" + symbol + ")",
      dataIndex: "billAmount",
      render: (_, record) => {
        const depositAmount = record.billAmount?.deposit.amount;
        const payableAmount = record.billAmount?.payableAmount;
        if (
          depositAmount !== undefined &&
          depositAmount !== null &&
          payableAmount !== undefined &&
          payableAmount !== null
        ) {
          const revenue = parseFloat(payableAmount) + parseFloat(depositAmount);
          return <span>{parseFloat(revenue).toFixed(2)}</span>;
        }
        return <span>0.00</span>;
      },
    },
  ];

  return (
    <DefaultLayout showSearch={false}>
      <div className="transaction-record-container">
        <div className="page-header"
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 'unset'
          }}>
          <h1>Transaction Record</h1>
          <div style={{ display: 'flex', gap: '8px' }}>
            <Button type="primary" onClick={handleTransactionDataPrint} disabled={!transactionData || transactionData.length === 0}>
              Export to Excel
            </Button>
            <Button type="primary" onClick={handleTransactionDataPrintSelected} disabled={!transactionData || transactionData.length === 0}>
              Print
            </Button>
          </div>
        </div>

        {/* Filters */}
        <div style={{ marginBottom: "24px" }}>
          <Row gutter={[16, 16]} style={{ alignItems: "center" }}>
            <Col xs={24} sm={12} md={8}>
              <RangePicker
                className="custom-date-picker"
                value={dateRange}
                onChange={handleDateRangeChange}
                style={{ width: "100%", height: 40 }}
                placeholder={["Start Date", "End Date"]}
                size="large"
                disabledDate={handleDisabledDate}

              />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <TimeRangePicker
                className="custom-time-picker"
                value={timeRange}
                onChange={handleTimeRangeChange}
                format="HH:mm"
                style={{ width: "100%", height: 40, minWidth: 180 }}
                placeholder={["Start Time", "End Time"]}
                size="large"
                allowClear
              />
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Select
                placeholder="Payment Method"
                suffixIcon={
                  methodOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
                onDropdownVisibleChange={handleMethodDropdownVisibleChange}
                value={selectedMethod}
                onChange={handlePaymentMethodChange}
                style={{ width: "100%", height: 40 }}
                size="large"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {paymentMethods.map((method) => (
                  <Select.Option key={method} value={method}>
                    {method}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Select
                placeholder="User ID"
                suffixIcon={
                  cashierOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
                onDropdownVisibleChange={handleCashierDropdownVisibleChange}
                value={selectedCashier}
                onChange={handleCashierNameChange}
                style={{ width: "100%", height: 40 }}
                size="large"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {cashierName.map((cashier) => (
                  <Select.Option key={cashier} value={cashier}>
                    {cashier}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Select
                placeholder="Table Number"
                suffixIcon={
                  tableOpen ? <CaretUpOutlined /> : <CaretDownOutlined />
                }
                onDropdownVisibleChange={handleTableDropdownVisibleChange}
                value={selectedTable}
                onChange={handleTableNumberChange}
                style={{ width: "100%", height: 40 }}
                size="large"
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
              >
                {tableNumber.map((table) => (
                  <Select.Option key={table} value={table}>
                    {table}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
        </div>

        {/* Table */}
        <Table
          columns={columns}
          dataSource={transactionData}
          bordered
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            pageSizeOptions: ['10', '20', '50'],
            showSizeChanger: transactionData.length > 10,
            showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
            onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
          }}
          summary={() => (
            <Table.Summary.Row>
              <Table.Summary.Cell index={0}></Table.Summary.Cell>
              <Table.Summary.Cell index={1}></Table.Summary.Cell>
              <Table.Summary.Cell index={2}></Table.Summary.Cell>
              <Table.Summary.Cell index={3}></Table.Summary.Cell>
              <Table.Summary.Cell index={4}></Table.Summary.Cell>
              <Table.Summary.Cell index={5}></Table.Summary.Cell>
              <Table.Summary.Cell index={6}></Table.Summary.Cell>
              <Table.Summary.Cell index={7}>
                <strong style={{ fontSize: "20px" }}>Total</strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={8}>
                <strong style={{ fontSize: "20px" }}>
                  {transactionData.reduce((sum, record) => {
                    const discount = record.billAmount?.discount;
                    return sum + (discount !== undefined && discount !== null ? parseFloat(discount) : 0);
                  }, 0).toFixed(2)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={9}>
                <strong style={{ fontSize: "20px" }}>
                  {transactionData.reduce((sum, record) => {
                    const subTotal = parseFloat(record.billAmount?.subTotal || 0);
                    const serviceSum = (record.billAmount?.services || []).reduce(
                      (acc, service) => acc + parseFloat(service.totalPrice || 0),
                      0
                    );
                    return sum + subTotal + serviceSum;
                  }, 0).toFixed(2)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={10}>
                <strong style={{ fontSize: "20px" }}>
                  {transactionData.reduce((sum, record) => {
                    const serviceSum = (record.billAmount?.services || []).reduce(
                      (acc, service) => acc + parseFloat(service.totalPrice || 0),
                      0
                    );
                    return sum + serviceSum;
                  }, 0).toFixed(2)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={11}>
                <strong style={{ fontSize: "20px" }}>
                  {transactionData.reduce((sum, record) => {
                    const depositAmount = record.billAmount?.deposit.amount;
                    return sum + (depositAmount !== undefined && depositAmount !== null ? parseFloat(depositAmount) : 0);
                  }, 0).toFixed(2)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={12}>
                <strong style={{ fontSize: "20px" }}>
                  {transactionData.reduce((sum, record) => {
                    const payableAmount = record.billAmount?.payableAmount;
                    return sum + (payableAmount !== undefined && payableAmount !== null ? parseFloat(payableAmount) : 0);
                  }, 0).toFixed(2)}
                </strong>
              </Table.Summary.Cell>
              <Table.Summary.Cell index={13}>
                <strong style={{ fontSize: "20px" }}>
                  {transactionData.reduce((sum, record) => {
                    const depositAmount = record.billAmount?.deposit.amount;
                    const payableAmount = record.billAmount?.payableAmount;
                    if (
                      depositAmount !== undefined &&
                      depositAmount !== null &&
                      payableAmount !== undefined &&
                      payableAmount !== null
                    ) {
                      return sum + parseFloat(payableAmount) + parseFloat(depositAmount);
                    }
                    return sum;
                  }, 0).toFixed(2)}
                </strong>
              </Table.Summary.Cell>
            </Table.Summary.Row>
          )}
        />

        {/* Invoice Modal */}
        <Modal
          title={
            <div>
              Receipt
              <CloseButton
                className="close-button"
                onClick={() => {
                  setTimeout(() => {
                    closeInvoiceModal();
                  }, 500);
                }}
              />
            </div>
          }
          open={showInvoiceModal}
          onCancel={() => {
            setTimeout(() => {
              closeInvoiceModal();
            }, 500);
          }}
          onOk={() => {
            invoiceRef.current?.printReceipt();
          }}
          okText="Print"
          className="print-modal"
          maskClosable={false}
        >
          <Invoice orders={selectedInvoice} ref={invoiceRef} />
        </Modal>
      </div>
    </DefaultLayout>
  );
};

export default TransactionRecord; 